import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { logError } from "~/common/logging";
import { parseApiError } from "~/Redux/Actions/errorActions";
import { useMounted } from "./useMounted";

type Action<T> = () => PromiseLike<T>;
type FetchOptions = { ignoreErrors?: boolean; resolveInstantly?: boolean; result?: any };

export const useFetchData = <T = any>(
    action: Action<T>,
    { ignoreErrors, resolveInstantly, result }: FetchOptions = {}
): [T, boolean] => {
    const [data, setData] = useState<T>(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const isMounted = useMounted();
    const dispatch = useDispatch();

    useEffect(() => {
        if (resolveInstantly) {
            setData(result);
            setIsLoaded(true);
        } else {
            action().then(
                resp => {
                    if (isMounted.current) {
                        setData(resp);
                        setIsLoaded(true);
                    }
                },
                e => {
                    logError(e as Error);

                    if (!ignoreErrors) {
                        let errorAction = parseApiError(e, undefined);
                        dispatch(errorAction);
                    } else if (isMounted.current) {
                        // mark the operation as done
                        setIsLoaded(true);
                    }
                }
            );
        }
    }, [resolveInstantly, result]);

    return [data, isLoaded];
};
